<app-loader *ngIf="isLoading"></app-loader>
<ng-container *ngIf="isLoading ; else  forms">
    <app-shimmer-loader [pagination]="false" type="profileShimmer">
    </app-shimmer-loader>
</ng-container>
<ng-template #forms>
    <div class="question-detail-container" *ngIf="!isLoading && data?.question">

        <!-- Question Section -->
        <div class="question-section">
            <div class="item-header">
                <mat-icon class="msg-icon">chat_bubble_outline</mat-icon>
                <span class="question-meta">Question by <span class="question-meta">{{ formatAuthor(data.question.author)
                        }}</span> in <a href="javascript:void(0)" class="category">{{ data.question.category
                        }}</a></span>
            </div>

            <div class="item-body">
                <div class="avatar-col">
                    <div class="avatar-circle">
                        <mat-icon>person</mat-icon>
                    </div>
                </div>
                <div class="content-col">
                    <h1 class="item-title">{{ data.question.title }}</h1>
                    <p class="item-desc">{{ data.question.content }}</p>

                    <div class="item-footer">
                        <span class="meta-info">{{ data.question.timeAgo }}</span>
                        <span class="meta-dot">•</span>
                        <span class="meta-info">{{ data.question.views }} Views</span>
                        <span class="meta-dot">•</span>
                        <span class="meta-info">{{ data.question.responses }} Response{{ data.question.responses !== 1 ?
                            's'
                            : '' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="divider"></div>

        <!-- Responses Section -->
        <div class="responses-section">
            <h2 class="responses-title">{{ data.question.responses }} Responses</h2>

            <!-- Top Reply Box -->
            <div class="reply-box">
                <div class="reply-header">
                    <div class="avatar-circle">
                        <mat-icon>person</mat-icon>
                    </div>
                    <span class="replying-to">Replying to <span class="highlight">{{ formatAuthor(data.question.author)
                            }}</span></span>
                </div>
                <div class="reply-input-area">
                    <textarea placeholder="Enter your response" [(ngModel)]="newReplyText"></textarea>
                    <div class="field-error" *ngIf="newReplyError">{{ newReplyError }}</div>
                    <div class="reply-actions">
                        <button mat-button class="communityQuestionsCancle" (click)="cancelTopReply(); newReplyError = ''">Cancel</button>
                        <button mat-flat-button class="communityQuestionsSubmit" (click)="submitReply()">Submit</button>
                    </div>
                </div>
            </div>

            <!-- Replies List -->
            <div class="replies-list">
                <div class="reply-item" *ngFor="let reply of data.question.replies; let i = index"
                    [attr.data-reply-id]="reply.id">
                    <div class="item-body">
                        <div class="avatar-col">
                            <div class="avatar-circle">
                                <mat-icon>person</mat-icon>
                            </div>
                        </div>
                        <div class="content-col">
                            <div class="reply-author-row">
                                <span class="author-name">{{ formatAuthor(reply.author) }}</span>
                                <span class="official-badge" *ngIf="reply.isOfficial">
                                    Official Response
                                    <mat-icon class="check-icon">check_circle</mat-icon>
                                </span>
                                <button mat-icon-button class="edit-btn"
                                    *ngIf="isAuthor(reply) && canEdit(reply) && !editingReply[i]"
                                    (click)="startEdit(i, reply)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button class="edit-btn" *ngIf="isAuthor(reply) && !canEdit(reply)"
                                    matTooltip="Editing expired" matTooltipPosition="above">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <div *ngIf="editingReply[i]" class="edit-area">
                                    <textarea [(ngModel)]="editText[i]"></textarea>
                                    <div class="field-error" *ngIf="editError[i]">{{ editError[i] }}</div>
                                    <div class="reply-actions">
                                        <button mat-button class="communityQuestionsCancle"
                                            (click)="cancelEdit(i)">Cancel</button>
                                        <button mat-flat-button class="communityQuestionsSubmit"
                                            (click)="submitEdit(i, reply)">Save</button>
                                    </div>
                                </div>
                            </div>

                            <p class="item-desc">{{ reply.content || reply.message || reply.body }}</p>

                            <div class="item-footer">
                                <span class="meta-info">{{ reply.timeAgo }}</span>
                                <span class="meta-dot">•</span>
                                <button class="reply-link" (click)="toggleInlineReply(i)">
                                    {{ reply.repliesCount || (reply.replies && reply.replies.length) || 0 }} Replies
                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                </button>
                                <span class="meta-dot" *ngIf="reply.isOfficial">•</span>
                                <span class="official-response-text" *ngIf="reply.isOfficial">Official Response
                                    <mat-icon>check_circle_outline</mat-icon></span>
                            </div>

                            <!-- Inline Reply Box -->
                            <div class="inline-reply-box" *ngIf="showInlineReply[i]">
                                <div class="reply-header">
                                    <div class="avatar-col">
                                        <div class="avatar-circle">
                                            <mat-icon>person</mat-icon>
                                        </div>
                                    </div>
                                    <span class="replying-to">Replying to <span class="highlight">{{
                                            formatAuthor(reply.author) }}</span></span>
                                </div>
                                <div class="reply-input-area">
                                    <textarea placeholder="Enter your reply"
                                        [(ngModel)]="inlineReplyText[i]"></textarea>
                                    <div class="field-error" *ngIf="inlineReplyError[i]">{{ inlineReplyError[i] }}</div>
                                    <div class="reply-actions">
                                        <button mat-button class="communityQuestionsCancle"
                                            (click)="cancelInlineReply(i); inlineReplyError[i] = ''">Cancel</button>
                                        <button mat-flat-button class="communityQuestionsSubmit" 
                                            (click)="submitInlineReply(i)">Submit</button>
                                    </div>
                                </div>
                            </div>

                            <!-- Nested Replies (show only when opened) -->
                            <div class="nested-replies"
                                *ngIf="showInlineReply[i] && reply.replies && reply.replies.length">
                                <div class="nested-reply-item" *ngFor="let r of reply.replies; let j = index"
                                    [attr.data-reply-id]="r.id">
                                    <div class="item-body nested">
                                        <div class="avatar-col">
                                            <div class="avatar-circle small">
                                                <mat-icon>person</mat-icon>
                                            </div>
                                        </div>
                                        <div class="content-col">
                                            <div class="reply-author-row">
                                                <span class="author-name">{{ formatAuthor(r.author) }}</span>
                                                <button mat-icon-button class="edit-btn"
                                                    *ngIf="isAuthor(r) && canEdit(r) && !editingNested[reply.id + '-' + j]"
                                                    (click)="editingNested[reply.id + '-' + j] = true; editNestedText[reply.id + '-' + j] = r.content || r.message || r.body || ''">
                                                    <mat-icon>edit</mat-icon>
                                                </button>
                                                <button mat-icon-button class="edit-btn"
                                                    *ngIf="isAuthor(r) && !canEdit(r)" matTooltip="Editing expired"
                                                    matTooltipPosition="above">
                                                    <mat-icon>edit</mat-icon>
                                                </button>
                                            </div>
                                            <p class="item-desc" *ngIf="!editingNested[reply.id + '-' + j]">{{ r.content
                                                ||
                                                r.message || r.body }}</p>
                                            <div *ngIf="editingNested[reply.id + '-' + j]"
                                                class="edit-area nested-edit">
                                                <textarea [(ngModel)]="editNestedText[reply.id + '-' + j]"></textarea>
                                                <div class="reply-actions">
                                                    <button mat-button class="communityQuestionsCancle"
                                                        (click)="editingNested[reply.id + '-' + j] = false">Cancel</button>
                                                    <button mat-flat-button class="communityQuestionsSubmit"
                                                        color="primary"
                                                        (click)="submitNestedEdit(reply, j)">Save</button>
                                                </div>
                                            </div>
                                            <div class="item-footer">
                                                <span class="meta-info">{{ r.timeAgo }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<div class="no-data" *ngIf="!isLoading && !data?.question">
    <app-data-unavailable></app-data-unavailable>
</div>